import { createBrowserHistory } from 'history'
import { applyMiddleware, createStore } from 'redux'
import { routerMiddleware } from 'connected-react-router'
import { composeWithDevTools } from 'redux-devtools-extension'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'

import createRootReducer from './reducer'

const persistConfig = {
  key: 'root',
  storage
}

export const history = createBrowserHistory()

export default function configureStore(preloadedState) {
  const store = createStore(
    persistReducer(persistConfig, createRootReducer(history)),
    preloadedState,
    composeWithDevTools(applyMiddleware(routerMiddleware(history)))
  )

  return store
}

export const store = configureStore()
export const persistor = persistStore(store)
